import React, { useEffect, useState } from "react";
import { Role } from "@/api/roles";
import RigthPanel from "@/ui-controls/RigthPanel";
import DeleteAppRoleForm from "@/components/roles/appRoles/DeleteAppRoleForm";

interface Props {
  role: Role | undefined;
  onDelete: (role: Role) => any;
  onClose: () => any;
}

const DeleteAppRolePanel = (props: Props) => {
  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  useEffect(() => {
    setIPanelOpen(props.role !== undefined);
  }, [props.role]);

  const onClosePanel = () => {
    setIPanelOpen(false);
    if (props.onClose) props.onClose();
  };

  return (
    <>
      <RigthPanel
        header="Delete Role"
        isOpen={isPanelOpen}
        dismissPanel={onClosePanel}
        childComponent={DeleteAppRoleForm}
        childProps={{
          role: props.role,
          onClose: () => onClosePanel(),
          onDelete: (role: Role) => {
            props.onDelete(role);
            onClosePanel();
          },
        }}
      />
    </>
  );
};

export default DeleteAppRolePanel;
